import { Button } from "@mui/material";

const CommonButton = ({
  onClick,
  variant = "contained",
  disabled = false,
  color = "primary",
  loading = false,
  fullWidth = false,
  children,
}) => {
  return (
    <Button
      variant={variant}
      color={color}
      disabled={disabled}
      loading={loading}
      fullWidth={fullWidth}
      sx={{ textTransform: "capitalize", fontSize: "15px" }}
      onClick={onClick}
    >
      {children}
    </Button>
  );
};

export default CommonButton;
